import { DeviceType } from '@/src/types/deviceType'
import { VasAncillary } from '@/src/types/itinerary'
import { TranslationFunction } from '@/src/types/translations'
import { Box } from '@mui/material'
import InsuranceFooterWrapper from './insuranceFooter'
import InsuranceItemWrapper from './insuranceItem'

const Insurance = ({
    insuranceList,
    selectedInsurances,
    termsAndConditionsUrl,
    isInsuranceTermsAndConditionsChecked,
    insuranceTermsAndConditionsError,
    handleInsuranceClick,
    onTermsChange,
    formatCurrency,
    t,
    deviceType
}: {
    insuranceList: VasAncillary[]
    selectedInsurances: VasAncillary[]
    termsAndConditionsUrl: string
    isInsuranceTermsAndConditionsChecked: boolean
    insuranceTermsAndConditionsError: boolean
    handleInsuranceClick: (insurance: VasAncillary, actionType: 'ADD' | 'REMOVE') => void
    t: TranslationFunction<'common'>
    formatCurrency: (amount: number) => string
    onTermsChange: () => void
    deviceType: DeviceType
}) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {insuranceList.map((insurance, index) => {
                const vasDetail = insurance.vasDetails?.[0]
                const {
                    text: title = '',
                    icon: imageSrc = '',
                    shortDescription = '',
                    description,
                    tripPremiumDetails: { totalPremiumAmount = 0 },
                    benefits = []
                } = vasDetail || {}

                const isSelected = selectedInsurances.some(
                    selectedInsurance => selectedInsurance.vasType === insurance.vasType
                )

                const onInsuranceClick = () => {
                    handleInsuranceClick(insurance, isSelected ? 'REMOVE' : 'ADD')
                }

                return (
                    <InsuranceItemWrapper
                        key={`${insurance.vasType}_${index}`}
                        id={`${insurance.vasType}_${index}`}
                        onInsuranceClick={onInsuranceClick}
                        imageSrc={imageSrc}
                        title={title}
                        description={description}
                        shortDescription={shortDescription}
                        totalPremiumAmount={formatCurrency(totalPremiumAmount)}
                        isSelected={isSelected}
                        t={t}
                        deviceType={deviceType}
                        benefits={benefits}
                    />
                )
            })}

            {/* Insurance Footer */}
            {!!insuranceList?.length && (
                <InsuranceFooterWrapper
                    insuranceTermsAndConditionsError={insuranceTermsAndConditionsError}
                    onTermsChange={onTermsChange}
                    termsAndConditionsUrl={termsAndConditionsUrl}
                    isInsuranceTermsAndConditionsChecked={isInsuranceTermsAndConditionsChecked}
                    t={t}
                />
            )}
        </Box>
    )
}

export default Insurance
